import { Component, Input } from '@angular/core';
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { ErrorMessageService } from '@core/service/error-message.service';
import { AuthService } from '@core';
import { Direction } from '@angular/cdk/bidi';
import moment from 'moment';
import { IntegerFormatPipe } from '@shared/pipe/integer-format.pipe';
import { ThousandSeparatorDirective } from '@shared/directive/app-thousand-separator.directive';
import { PrintService } from '@core/service/print.service';
import {
  NgbActiveModal,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap';

export interface DialogData {
  id: number;
  action: string;
  item: any;
}
@Component({
  selector: 'app-modal-reglement-reservation',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IntegerFormatPipe,
    ThousandSeparatorDirective,
  ],
  templateUrl: './modal-reglement-reservation.component.html',
  styleUrl: './modal-reglement-reservation.component.scss'
})
export class ModalReglementReservationComponent {
  //  action: string;
  // bookingForm: UntypedFormGroup;
  // booking: Article;
  @Input() data: any = {};
  client_search_key: any
  itemToSave: any = {};
  itemsNationnalite: any = [
    { user_nationnalite_name: 'IVOIRIENNE', user_nationnalite_id: 'IVOIRIENNE' },
    { user_nationnalite_name: 'BURKINABE', user_nationnalite_id: 'BURKINABE' },
    { user_nationnalite_name: 'SENEGALAIS', user_nationnalite_id: 'SENEGALAIS' },
  ]
  itemsNaturePiece: any = [
    { nature_piece_name: 'CARTE_IDENTITE', user_nature_of_piece: 'CARTE_IDENTITE' },
    { nature_piece_name: 'PASSEPORT', user_nature_of_piece: 'PASSEPORT' },
    { nature_piece_name: 'PERMIS_CONDUIRE', user_nature_of_piece: 'PERMIS_CONDUIRE' },
  ]
  createMessage = ''
  editMessage = ''
  deleteMessage = ''
  gender = 'M'
  entity = 'booking';
  isLoading: boolean = false;
  itemsRoom: any;
  endPoint: string = "reglementReservation";
  title = 'règlement réservation'


  itemClient: any = {}
  user: any = {};
  itemsService: any;
  itemsChambre: any;
  itemsClient: any;

  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  } | undefined;
  loading: boolean | undefined;
  itemsModeReglement: any = [];
  itemsUserCaisse: any;
  showTimeFiels: boolean = false;
  duree_jours: any = 0;
  duree_heures: any = 0;
  itemsReglementReservation: any;
  clientFidelite: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private errorMessage: ErrorMessageService,
    private authService: AuthService,
    private modalService: NgbModal,
    public printService: PrintService
  ) {
    this.user = this.authService.getCurrentUser()
    let text1 = this.gender == 'M' ? 'un' : 'une'
    this.createMessage = 'Vous êtes sur le point de créer ' + text1 + ' ' + this.title
    this.editMessage = 'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title
    this.deleteMessage = 'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title
    this.getItemsService()
    this.getItemsModeReglement()
    this.getitemsUserCaisse()
  }

  ngOnInit(): void {
    this.itemToSave = { ...this.data };
    this.getItemsReglementReservation();
    if (this.itemToSave.client_id) {
      this.getClientFidelite(this.itemToSave.client_id);
    }
  }

  getClientFidelite(clientId: number) {
    this.restClient.post('client/getByCriteria', { data: { id: clientId }, index: 0, size: 1 })
      .subscribe((res: any) => {
        if (res && !res['hasError'] && res['items']?.length) {
          this.clientFidelite = res['items'][0].fidelite ?? null;
        }
      });
  }

  canUseFidelity(): boolean {
    if (!this.clientFidelite) return false;
    const montantEquiv = this.clientFidelite.montant_equivalent ?? 0;
    const montantARegler = this.itemToSave.montant ?? 0;
    return montantEquiv >= montantARegler;
  }

  isFidelitySelected(): boolean {
    const selected = this.itemsModeReglement.find((m: any) => m.id == this.itemToSave.mode_reglement_id);
    return selected?.codification === 'FIDELITY';
  }

  submit() {

  }

  confirmSaveItem(item: any) {



    if (!item.id)
      item.code = this.generateUniqueString()
    let objToSave = Object.assign({}, item);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id
        ? this.editMessage
        : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        // objToSave.code = objToSave.code.trim().toUpperCase();
        this.saveItem(objToSave);
      }
    });
  }

  saveItem(item: any) {
    console.info("item to save", item);

    this.isLoading = true;

    let itemAEnregistrer = Object.assign({}, item);

    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }

    let reduce = [];

    itemAEnregistrer.groupe_id = this.user.groupe_id
    itemAEnregistrer.hotel_id = this.user.hotel_id

    itemAEnregistrer.reservation_id = this.itemToSave.id

    itemAEnregistrer.client_id = this.itemToSave.client_id
    itemAEnregistrer.apporteur_id = this.itemToSave.apporteur_id


    itemAEnregistrer.is_ristourne = false;
    itemAEnregistrer.is_validated = true;




    var request = {
      datas: [itemAEnregistrer],
    };

    this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/create" : "/create"),
        request
      )
      .subscribe(
        (res: any) => {
          console.info("resul", res);
          this.isLoading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            // this.currentPage = 0
            this.activeModal.close(res.item)
            this.imprimerReglement(res.item)
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }
  getItemsService() {
    this.itemsChambre = []
    let request = {
      data: {
        can_reservation: true
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("service/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsService = res["items"];

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsService = [];
          }
        },
        (err) => {
          this.itemsService = [];

        }
      );
  }
  voirPreuveReglement(item: any) {
    if (!item.image_url) return;
    Swal.fire({
      title: 'Preuve de paiement', imageUrl: item.image_url, imageAlt: 'Justificatif du règlement',
      confirmButtonText: 'Fermer', confirmButtonColor: '#0665aa', width: 640,
      didOpen: () => {
        const image = Swal.getImage();
        if (image) { image.style.maxHeight = '65vh'; image.style.objectFit = 'contain'; }
      },
    });
  }

  getItemsReglementReservation() {
    if (!this.itemToSave.id) return
    let request = {
      for_history: true,
      data: {
        reservation_id: this.itemToSave.id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("reglementReservation/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsReglementReservation = res["items"];

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsReglementReservation = [];
          }
        },
        (err) => {
          this.itemsReglementReservation = [];

        }
      );
  }
  getItemsModeReglement() {
    // this.itemsChambre = []
    let request = {
      data: {
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("modeReglement/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsModeReglement = res["items"];

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsModeReglement = [];
          }
        },
        (err) => {
          this.itemsModeReglement = [];

        }
      );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split(".")[0];
      const Tabextension = file.name.split(".");
      const extension = Tabextension[Tabextension.length - 1];

      console.info("fileName", fileName);
      console.info("extension", extension);
      this.imageName = fileName + "." + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(",")[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: "custom type",
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  getitemsChambre() {
    let request = {
      data: {
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("chambre/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsChambre = res["items"];

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsChambre = [];
          }
        },
        (err) => {
          this.itemsChambre = [];

        }
      );
  }

  getitemsUserCaisse() {

    let request = {
      add_caisse_status: true,
      data: {
        user_id: this.user.id,
        hotel_id: this.user.hotel_id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("userCaisse/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsUserCaisse = res["items"];
            this.itemsUserCaisse = this.itemsUserCaisse.filter((ic: any) => ic.is_open)


          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsUserCaisse = [];
          }
        },
        (err) => {
          this.itemsUserCaisse = [];

        }
      );
  }

  onSearchClient(client_id?: any) {
    // if(!this.client_search_key) return
    let request = {
      chambre_status: 'AVAILABLE',// POUR RECUPER UNIQUEMENT LES CHAMBRES DISPONIBLES
      service_id: this.itemToSave.service_id,
      debut_reservation: this.itemToSave.debut_reservation,
      fin_reservation: this.itemToSave.fin_reservation,
      search_key: this.client_search_key,
      data: {
        // telephone:this.client_search_key
        id: client_id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("client/getByCriteria", request)
      .subscribe(
        (res: any) => {
          if (res && res["items"] && !res['hasError']) {
            this.itemsClient = res["items"];
            if (client_id)
              this.itemToSave.client_id = client_id

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsClient = [];
          }
        },
        (err) => {
          this.itemsClient = [];

        }
      );
  }
  onGetChambreDisponible() {

    this.itemToSave.chambre_id = null
    this.getitemsChambre()
  }

  calculatePrice() {
    // debugger
    if (this.itemToSave.chambre_id && !this.showTimeFiels) {
      const selected_chambre = this.itemsChambre.find((ic: any) => ic.id == this.itemToSave.chambre_id)
      const dateDebut = moment(this.itemToSave.debut_reservation);
      const dateFin = moment(this.itemToSave.fin_reservation);
      const jours = dateFin.diff(dateDebut, 'days');
      this.duree_jours = jours
      this.itemToSave.montant_total = this.duree_jours * selected_chambre.montant_service
    }
    else {
      if (this.itemToSave.chambre_id) {
        const selected_chambre = this.itemsChambre.find((ic: any) => ic.id == this.itemToSave.chambre_id)
        this.itemToSave.montant_total = selected_chambre.montant_service
        this.duree_heures = 10
      }
    }
  }

  onSetHeure() {
    const selected_service = this.itemsService.find(
      (is: any) => is.id === this.itemToSave.service_id
    );

    this.showTimeFiels = false;

    if (selected_service?.periodicite_heure_debut && selected_service?.periodicite_heure_fin) {
      this.showTimeFiels = true;

      this.itemToSave.heure_debut_reservation = selected_service.periodicite_heure_debut;
      this.itemToSave.heure_fin_reservation = selected_service.periodicite_heure_fin;

      if (this.itemToSave.debut_reservation && this.itemToSave.heure_debut_reservation) {
        const t = moment(this.itemToSave.heure_debut_reservation, 'HH:mm');

        // Make sure debut_reservation is a moment object
        let debutMoment = moment(this.itemToSave.debut_reservation);

        if (t.isValid() && t.format('HH:mm') === '20:00') {
          // Add 1 day
          debutMoment.add(1, 'days');
        }
        // Set fin_reservation
        this.itemToSave.fin_reservation = debutMoment.toDate();
      }
    }
    this.onGetChambreDisponible()
  }

  openDialog(action: 'add' | 'edit', data?: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }
    const modalRef = this.modalService.open(/* TODO: replace MatDialog with correct component */ null as any, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.closed.subscribe((result) => {
      console.log("result: ", result)
      if (result && result.id)
        this.onSearchClient(result.id)
    });
  }

  generateUniqueString() {
    var timestamp = new Date().getTime();
    var randomNumber = Math.floor(Math.random() * 1000000);

    var uniqueString = timestamp.toString() + randomNumber.toString();
    return uniqueString;
  }
  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  onCalculateMonnaie() {
    debugger
    if (this.itemToSave.montant > 0 && this.itemToSave.montant_recu > 0 && this.itemToSave.montant_recu > this.itemToSave.montant) {
      this.itemToSave.monnaie_rendue = this.itemToSave.montant_recu - this.itemToSave.montant
    }
    if (this.itemToSave.montant > this.itemToSave.montant_recu) {
      //  this.itemToSave.montant_recu = this.itemToSave.montant
      this.itemToSave.monnaie_rendue = 0
    }
  }

  imprimerReglement(item: any) {
    let request = {
      data: {
        // telephone:this.client_search_key
        id: item.id
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post("pdf/printRecuReservation", request)
      .subscribe(
        (res: any) => {
          if (res && res["item"] && !res['hasError']) {

            this.printService.previewPdf(res['item'].link)

          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
          }
        },
        (err) => {

        }
      );
  }
}
